import { useContext } from 'react';

import audioSrc from '@/assets/music/lyoc_ost_1.mp3';
import { ViewContext } from '@/state/contexts';

import ActionButton from './ActionButton';

const MusicController = () => {
	const {
		audioRef,

		setVolume,
		volume,

		setHasStarted,
		hasStarted,

		setIsPlaying,
		isPlaying,

		verboseSettings,
	}: any = useContext(ViewContext); // numPlayers, monthTracker, seasonTracker, carbonReservoir,

	const handleTogglePlay = () => {
		if (!audioRef.current) {
			const audio = new Audio(audioSrc);
			audio.loop = true;
			audio.volume = volume;
			audio.play();
			audioRef.current = audio;
			setHasStarted(true);
			setIsPlaying(true);
		} else {
			if (audioRef.current.paused) {
				audioRef.current.play();
				setIsPlaying(true);
				setHasStarted(true);
			} else {
				audioRef.current.pause();
				setIsPlaying(false);
			}
		}
	};

	const handleStop = () => {
		if (audioRef.current) {
			audioRef.current.pause();
			audioRef.current.currentTime = 0;
			setIsPlaying(false);
			setHasStarted(false);
		}
	};

	const handleVolumeChange = (e) => {
		const vol = parseFloat(e.target.value);
		setVolume(vol);
		if (audioRef.current) {
			audioRef.current.volume = vol;
		}
	};

	if (!hasStarted) {
		return (
			<ActionButton
				leftEmoji="⏯️"
				leftText="Music"
				onClickFunc={() => {
					handleTogglePlay();
				}}
			/>
		);
	}

	return (
		<>
			{verboseSettings && (
				<label style={{ display: 'block', marginTop: '1rem' }}>
					Volume:
					<input
						type="range"
						min="0"
						max="1"
						step="0.01"
						value={volume}
						onChange={handleVolumeChange}
					/>
				</label>
			)}
			<div className="flexRow">
				<ActionButton
					leftEmoji="⏯️"
					rightText={isPlaying ? 'Play' : 'Pause'}
					onClickFunc={() => {
						handleTogglePlay();
					}}
				/>{' '}
				:
				{verboseSettings && (
					<ActionButton
						leftEmoji="🛑"
						rightText="Stop"
						onClickFunc={() => {
							handleStop();
						}}
					/>
				)}
			</div>
		</>
	);
};

export default MusicController;
